<template>
  <div style="height:100vh;background:#fff;overflow:scroll;overflow-x:hidden">
 
<div class="d-flex align-items-center justify-content-center" v-if='addbox' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:100000000">
  <div v-on:click="addbox=false"  style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:-1"></div>


<div style="width:500px;padding:30px;background:#fff;position:relative;z-index:1000000">
  <form v-on:submit.prevent='adduser'>
    <label style="font-size:16px;color:#000;font-weight:600">Name</label>
    <input type="text" required="" v-model='name' class="form-control" style="height:50px" name="">
    <label style="font-size:16px;color:#000;font-weight:600" class="mt-4">Creator ID</label>
    <input type="text" required="" v-model='cid' class="form-control" style="height:50px" name="">
    <label style="font-size:16px;color:#000;font-weight:600" class="mt-4">Board ID</label>
     <input type="text" required="" v-model='bid' class="form-control" style="height:50px" name="">
    <label style="font-size:16px;color:#000;font-weight:600" class="mt-4">Channel ID</label>
    <input type="text" required="" v-model='chid' class="form-control" style="height:50px" name="">
    <button class="form-control mt-4" style="background:#11B98F;color:#fff">Add Manager</button>
  </form>
</div>


</div>

<div class="d-flex align-items-center justify-content-center" v-if='editbox' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:100000000">
  <div v-on:click="editbox=false"  style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:-1"></div>


<div style="width:500px;padding:30px;background:#fff;position:relative;z-index:1000000">
  <form v-on:submit.prevent='edituser'>
    <label style="font-size:16px;color:#000;font-weight:600">Name</label>
    <input type="text" required="" v-model='name' class="form-control" style="height:50px" name="">
    <label style="font-size:16px;color:#000;font-weight:600" class="mt-4">Creator ID</label>
    <input type="text" required="" v-model='cid' class="form-control" style="height:50px" name="">
    <label style="font-size:16px;color:#000;font-weight:600" class="mt-4">Board ID</label>
     <input type="text" required="" v-model='bid' class="form-control" style="height:50px" name="">
    <label style="font-size:16px;color:#000;font-weight:600" class="mt-4">Channel ID</label>
    <input type="text" required="" v-model='chid' class="form-control" style="height:50px" name="">
    <button class="form-control mt-4" style="background:#11B98F;color:#fff">Edit Manager</button>
  </form>
</div>


</div>




<div class="d-flex align-items-center justify-content-center" v-if='editboxsss' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:100000000">
  <div v-on:click="editboxsss=false"  style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:-1"></div>


<div style="width:500px;padding:30px;background:#fff;position:relative;z-index:1000000">
  <form v-on:submit.prevent='editusers'>
    <label style="font-size:16px;color:#000;font-weight:600">Name</label>
    <input type="text" required="" v-model='name' class="form-control" style="height:50px" name="">
   
    <label style="font-size:16px;color:#000;font-weight:600" class="mt-4">Board ID</label>
    <input type="text" required="" v-model='bid' class="form-control" style="height:50px" name="">
     
     <button class="form-control mt-4" style="background:#11B98F;color:#fff">Edit User</button>
  </form>
</div>


</div>



<div class="d-flex align-items-center justify-content-center" v-if='addboxs' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:100000000">
  <div v-on:click="addboxs=false"  style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:-1"></div>


<div style="width:500px;padding:30px;background:#fff;position:relative;z-index:1000000">
  <form v-on:submit.prevent='addusers'>
    <label style="font-size:16px;color:#000;font-weight:600">Name</label>
    <input type="text" required="" v-model='name' class="form-control" style="height:50px" name="">


 
    <label style="font-size:16px;color:#000;font-weight:600" class="mt-4">Board ID</label>
     <input type="text" required="" v-model='bid' class="form-control" style="height:50px" name="">
     
    <button class="form-control mt-4" style="background:#11B98F;color:#fff">Add Member</button>
  </form>
</div>


</div>



<div class="d-flex align-items-center justify-content-center" v-if='delbox' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:100000000">
  <div v-on:click="delbox=false"  style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:-1"></div>


<div style="width:400px;padding:30px;background:#fff;position:relative;z-index:1000000">
   <h2 style="text-align:center;font-weight:500;color:#000;font-size:18px;margin-bottom:20px">Are you sure?</h2>
   <div class="d-flex align-items-center">
     <div style="padding-right:10px;flex:1">
       <div v-on:click='delbox=false' style="text-align:center;padding:10px;color:#11B98F;border:1px solid #11B98F;border-radius:4px">Cancel</div>
     </div>
      <div style="padding-right:10px;flex:1">
       <div v-on:click='deleteconf' style="text-align:center;padding:10px;color:#fff;background:#11B98F;border-radius:4px">Confirm</div>
     </div>
   </div>
</div>


</div>




<div class="" v-if='drawer' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:100000000">
  <div v-on:click="drawer=false"  style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:-1"></div>








  <div style=" " v-if='signedin' class="py-5 px-3 drawbox">
    


   <div class="nabelm  ">
                
                

                <div   class="   mr-2  drpmain" style="position:relative">
                  <div style="margin:auto;width:60px;border-radius:50%;overflow:hidden;cursor:pointer" v-if="signedinby=='google'">
                    <img :src='profileimg' style="width:100%">
                  </div>
                    <div style="margin:auto;width:60px;border-radius:50%;overflow:hidden;cursor:pointer;height:60px;background:#53BA90"  class="d-flex align-items-center justify-content-center" v-if="signedinby=='email'">
                   <p style="font-size:18px;color:#fff;">{{profiletext}}</p>
                  </div>
                    <p style="color:#2E3A5E;font-weight:500;font-size:20px;margin-top:15px;text-align:center">{{name}}</p>

                    <div style="background:#E7E9F2;height:1px;margin: 20px -24px;"></div>

                
                
                </div>

 
             
                </div>

                   <div class="nabelm mt-4 ">
                  <router-link to='/orders'>
                  <p style="margin-bottom: 0px;color:#2E3A5E;font-size:18px;font-weight:400">View Favourites</p>
                </router-link>
                </div>


                 <div class="nabelm mt-4 ">
                  <router-link to='/orders'>
                  <p style="margin-bottom: 0px;color:#2E3A5E;font-size:18px;font-weight:400">View Orders</p>
                </router-link>
                </div>
                 
                  <div class="nabelm mt-4 ">
                  <router-link to='/orders'>
                  <p style="margin-bottom: 0px;color:#2E3A5E;font-size:18px;font-weight:400">Favorite</p>
                </router-link>
                </div>
                 
                   <div class="nabelm mt-4 ">
 <router-link to='/contact'>
                  <p style="margin-bottom: 0px;color:#2E3A5E;font-size:18px;font-weight:400">Contact</p>
                </router-link>
                </div>
                 
                  <div class="nabelm mt-4 " v-on:click='signout()'>

                  <p style="margin-bottom: 0px;color:#2E3A5E;font-size:19px;font-weight:400">Logout</p>
                </div>
                 





    <div>
      
    </div>
  </div>
























  <div  v-if='!signedin' class="py-5 px-3 drawbox">
    

   <div class="nabelm d-flex align-items-center " >
                
                
 

                  <div class="nabelm  loginbtn"  v-on:click='loginroute()' style="">
                  <p style="margin-bottom: 0px;color:#53BA90;font-size:15px;font-weight:500">Log in</p>
                </div>

             
                </div>
                   
                 
      
                 <div class="nabelm mt-4 ">
                  <router-link to='/orders'>
                  <p style="margin-bottom: 0px;color:#2E3A5E;font-size:18px;font-weight:400">View Orders</p>
                </router-link>
                </div>
                 
               
                   <div class="nabelm mt-4 ">
 <router-link to='/contact'>
                  <p style="margin-bottom: 0px;color:#2E3A5E;font-size:18px;font-weight:400">Contact</p>
                </router-link>
                </div>
                 






    <div>
      
    </div>
  </div>













</div>








 
 
<div class="header py-md-5 pt-md-0 pt-3 ">
 <div class="container py-1 "  >
      <div  style="padding:0px;margin:0px">





  <header id="header" class="header" role="banner" style="padding:0px">
    
    <div class="inner d-flex align-items-center justify-content-center" style="padding:0px;width:100%;max-width:100%">
       <div class="logo">
           <router-link to='/' style="text-decoration:none!important;">
                    <img src="https://websitelearners.com/content/uploads/2016/09/logo.svg" alt="Website Learners" width="275" height="42" />
                  </router-link>
      </div>
           
 
          

           
                </div>
  </header>
</div>
</div>
</div>






  <div class="header py-5  d-none " style=" ">
    <div class="container py-1 "  >
      <div class="row" style="padding:0px;margin:0px">
        <div class="col-12" style="padding:0px;margin:0px">
          <div class=" d-flex align-items-center justify-content-between">
            <router-link to='/'>
              <img src="https://websitelearners.com/app/uploads/2016/09/logo.svg" style="" class="headlogo" >
            </router-link>
              <img src="https://firebasestorage.googleapis.com/v0/b/wl-shopping.appspot.com/o/images%2FMenu%20Icon.svg?alt=media&token=31566e5e-fb81-41b1-9032-e97da43a1254" class="d-md-none d-block" v-on:click='drawer=true' style="width:30px">
              <div class="d-md-flex  d-none align-items-center">
                 <div class="nabelm ml-4 mr-2" v-if='signedin'>
                  <router-link to='/favourites' >
                  <p style="margin-bottom: 0px">View Favourites</p>
                </router-link>
                </div>
                <div class="nabelm ml-4 mr-2" v-if='signedin'>
                  <router-link to='/orders' >
                  <p style="margin-bottom: 0px">View Orders</p>
                </router-link>
                </div>
                 
                   <div class="nabelm ml-4 mr-2">
                     <router-link to='/contact'>
                  <p style="margin-bottom: 0px">Contact</p>
                </router-link>
                </div>
                 
                

                <div v-if='signedin' class="d-flex align-items-center ml-4 mr-2  drpmain" style="position:relative">
                  <div style="width:33px;border-radius:50%;overflow:hidden;cursor:pointer" v-if="signedinby=='google'">
                    <img :src='profileimg' style="width:100%">
                  </div>

                    <div style="width:33px;border-radius:50%;overflow:hidden;cursor:pointer;height:33px;background:#53BA90"  class="d-flex align-items-center justify-content-center" v-if="signedinby=='email'">
                   <p style="font-size:18px;color:#fff;">{{profiletext}}</p>
                  </div>

                  <div style="padding-top:20px" class="drppro" >

                      <div style="background:#fff;box-shadow:0 0 10px rgba(0,0,0,0.1);">
                  <div class="nabelm  "  style="padding:14px 20px;border-bottom:1px solid #ccc;cursor:pointer">
                    <router-link to='editprofile'>
                  <p style="margin-bottom: 0px;font-size:15px">Edit Profile</p>
                </router-link>
                </div>
                    <div class="nabelm   "  style="padding:14px 20px;;cursor:pointer " v-on:click='signout()'>
                  <p style="margin-bottom: 0px;color:#53BA90;font-size:15px;font-weight:500">Log out</p>
                </div>
              </div>

                  </div>

                </div>





                  <div class="nabelm ml-4 mr-2 loginbtn" v-if='!signedin' v-on:click='loginroute()' style="">
                  <p style="margin-bottom: 0px;color:#53BA90;font-size:15px;font-weight:500">Log in</p>
                </div>
                  

              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

 

<div   >


<div style="min-height:calc(100vh - 210px) " class="d-flex align-items-center">


<div class="container" style="background:#fff;padding:40px;margin-top:0px; "  v-if='formsubmited' >
  <div class="row justify-content-center">
   
       
   
     <div class="col-md-8 " >
       <h2 style="text-align:center;color:#182160;font-size:50px;font-weight:600">Your response has been recorded. <br> We thank you for your participation..!</h2>
     </div>

 
 </div>
</div>
<div class="container" style="background:#F8FBFF;padding:40px;margin-top:0px; " v-if='!formsubmited'>
  <div class="row justify-content-center">
     <template v-for='(itm,index) in question'>
       
   
     <div class="col-md-10  " v-if="itm.type=='input' && tab==itm.id">
       <div style="background:#fff;padding:30px;border-radius:10px; " class="anims">
         <div class="d-flex">
           <h1 style="margin-bottom:0px;color:#9599B2;font-weight:600;font-size:30px"><sup style="color:#16205F;font-size:16px;transform:translateY(-7px);vertical-align:middle;margin-right:4px">*</sup>{{ ss=index+1 }}.  </h1>
           <form class=""  v-on:submit.prevent="index==question.length-1?submit():setroute(itm.id)" style="padding-left:10px;flex:1">
             <p style="border-left:1px solid #9599B2;padding-bottom:4px;font-weight:500;font-size:30px;padding-left:10px;color:#16205F">{{itm.title}}</p>
             <div style="background:#F7F7F8;margin-left:10px; margin-top:10px">
               <input type="text" class="form-control cform" v-model='itm.answer' style="width:100%;background:transparent;outline:none;border:none;height:50px;box-shadow:none;font-size:20px" placeholder="Enter your answer here" name="">
             </div>
             <p style="font-size:13px;color:#fff;margin-left:10px;margin-top:10px;background:#DC5141;display:inline-block;padding:4px 15px;border-radius:5px" v-if="itm.error && itm.answer==''">This Field must not empty</p>
             


           <div class="d-flex align-items-center mt-3">

             <div>

             <div  class="d-flex align-items-center" v-if="itm.answer!='' && index!=question.length-1" style="padding:0px;cursor:pointer">
               <button class=" " style="background:#11B98F;padding:3px 20px;border-radius:5px;color:#fff;font-weight:500;font-size:16px;border:none;outline:none;box-shadow:none">Next</button>
             </div>
            

             <div  class="d-flex align-items-center" v-if="itm.answer!='' && index==question.length-1" style="padding:0px;cursor:pointer">
                 <button class=" " style="background:#11B98F;padding:3px 20px;border-radius:5px;color:#fff;font-weight:500;font-size:16px;border:none;outline:none;box-shadow:none">Submit</button>
             </div>
                  </div>

<div class="d-flex justify-content-end" style="margin-left:auto">
 
          <div class="d-flex align-items-center mx-2">
         <div  v-if='tab!=0' class="d-flex align-items-center justify-content-center"  v-on:click="setstate('up',itm,index)"  style="cursor:pointer;margin:0px 0px;width:30px;height:30px;border-radius:4px;background:#11B98F">
               <i class='bx bx-chevron-up' style="font-size:20px;color:#fff"></i>
         </div>
          <div  v-else  class="d-flex align-items-center justify-content-center"   style="cursor:pointer;margin:0px 0px;width:30px;height:30px;border-radius:4px;background:#11B98F;opacity:0.5">
               <i class='bx bx-chevron-up' style="font-size:20px;color:#fff"></i>
         </div>
       </div>
         <div class="d-flex align-items-center mx-2">
         <div  v-if='tab!=question.length-1' class="d-flex align-items-center justify-content-center"  v-on:click="setstate('down',itm,index)"  style="cursor:pointer;margin:0px 0px;width:30px;height:30px;border-radius:4px;background:#11B98F">
               <i class='bx bx-chevron-down' style="font-size:20px;color:#fff"></i>
         </div>
          <div  v-else  class="d-flex align-items-center justify-content-center"   style="cursor:pointer;margin:0px 0px;width:30px;height:30px;border-radius:4px;background:#11B98F;opacity:0.5">
               <i class='bx bx-chevron-down' style="font-size:20px;color:#fff"></i>
         </div>
       </div>


                </div>


              





           </div>



           </form>
         </div>
       </div>
      
         
     </div>

 <div class="col-md-10"  v-if="itm.type=='option' && tab==itm.id">
       <div style="background:#fff;padding:30px;border-radius:10px;" class="anims">
         <div class="d-flex">
           <h1 style="margin-bottom:0px;color:#9599B2;font-weight:600;font-size:30px"><sup style="color:#16205F;font-size:16px;transform:translateY(-7px);vertical-align:middle;margin-right:4px">*</sup>2. </h1>
           <div class="" style="padding-left:10px;flex:1">
             <p style="border-left:1px solid #9599B2;padding-bottom:4px;font-weight:500;font-size:30px;padding-left:10px;color:#16205F">{{itm.title}}
</p>
             
             <div style="padding-left:10px" >
              <template v-for='(it,index) in itm.options'>
                
             
               <div class="d-flex align-items-start p-3 hovef"  v-on:click='setmore(it,itm.id,itm)'>
                 <div class="d-flex align-items-center" style="cursor:pointer">
                   <div style="width:26px;height:26px;border-radius:4px;color:#2A364D;font-weight:500;font-size:15px;background:#fff;border:1px solid #2A364D" class="d-flex align-items-center justify-content-center"><span>{{++index}}</span></div>
                   <p style="margin-bottom:0px;color:#2A364D;font-weight:400;margin-left:15px;font-size:18px">{{it}}</p>
                 </div>
               </div>
                </template>
             </div>
                  <div class="d-flex justify-content-end mt-3" style="margin-left:auto">

          <div class="d-flex align-items-center mx-2">
         <div  v-if='tab!=0' class="d-flex align-items-center justify-content-center" v-on:click="setstate('up',itm,index)"   style="cursor:pointer;margin:0px 0px;width:30px;height:30px;border-radius:4px;background:#11B98F">
               <i class='bx bx-chevron-up' style="font-size:20px;color:#fff"></i>
         </div>
          <div  v-else  class="d-flex align-items-center justify-content-center"   style="cursor:pointer;margin:0px 0px;width:30px;height:30px;border-radius:4px;background:#11B98F;opacity:0.5">
               <i class='bx bx-chevron-up' style="font-size:20px;color:#fff"></i>
         </div>
       </div>
         <div class="d-flex align-items-center mx-2">
         <div  v-if='tab!=question.length-1' class="d-flex align-items-center justify-content-center"  v-on:click="setstate('down',itm,index)"  style="cursor:pointer;margin:0px 0px;width:30px;height:30px;border-radius:4px;background:#11B98F">
               <i class='bx bx-chevron-down' style="font-size:20px;color:#fff"></i>
         </div>
          <div  v-else  class="d-flex align-items-center justify-content-center"   style="cursor:pointer;margin:0px 0px;width:30px;height:30px;border-radius:4px;background:#11B98F;opacity:0.5">
               <i class='bx bx-chevron-down' style="font-size:20px;color:#fff"></i>
         </div>
       </div>





           </div>

           </div>
         </div>
       </div>

     </div>




  </template>

  </div>
</div>
</div>






  <div class=" d-none   " style="padding-bottom: 7px!important;margin-top:100px">
 
    <div class="container   mainboxs " style="padding:30px!important">
 
     
        

        <div class="row align-items-center"  style="background:#fff"> 
            <div class="col-md-3 px-4 py-3" style="border-right:1px solid #ccc;border-left:1px solid #ccc">
              <h2 style="color:#000;font-weight:600;font-size:14px;margin-bottom:0px">Name</h2>
            </div>         
            <div class="col-md-3 px-4 py-3" style="border-right:1px solid #ccc">
              <h2 style="color:#000;font-weight:600;font-size:14px;margin-bottom:0px">Creator ID</h2>
            </div>         
            <div class="col-md-3 px-4 py-3">
              <h2 style="color:#000;font-weight:600;font-size:14px;margin-bottom:0px">Board ID</h2>
            </div>  
            <div class="col-md-3 d-flex justify-content-end">
              <div v-on:click='addbox=true' style="width:30px;height:30px;border-radius:30px;background:#11B98F" class="d-flex align-items-center justify-content-center">
                <i class='bx bx-plus' style="color:#fff;font-size:17px"></i>
              </div>
            </div>        
        </div>
        <template v-for='itm in leads'>
         <div class="row align-items-center"  > 
            <div class="col-md-3 px-4 py-4" style=" ">
              <h2 style="color:#000;font-weight:500;font-size:18px;margin-bottom:0px">{{itm.name}}</h2>
            </div>         
            <div class="col-md-3 px-4 py-4" style=" ">
              <h2 style="color:#000;font-weight:500;font-size:18px;margin-bottom:0px">{{itm.creatorid}}</h2>
            </div>         
            <div class="col-md-3 px-4 py-4">
              <h2 style="color:#000;font-weight:500;font-size:18px;margin-bottom:0px">{{itm.boardid}}</h2>
            </div>   
             <div class="col-md-3 d-flex justify-content-end">
              <div v-on:click='delboxs(itm)' style="width:30px;height:30px;border-radius:30px;background:#11B98F" class="d-flex align-items-center justify-content-center">
                <i class='bx bx-trash' style="color:#fff;font-size:17px"></i>
              </div>
            </div>            
        </div>
        </template>


  
    



    </div>
  </div>

</div>

 
 
<div class="" style="background:#F9FBFE;padding:10px 0 ;font-family: 'Inter', sans-serif!important;">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <router-link to='/formtest?id=2'>
            <img src="https://websitelearners.com/app/uploads/2016/09/logo.svg" style="width:200px" class="img-fluid">
          </router-link>
          </div>
          <p style="color:#98A5B6;font-size:18px;font-weight:400;margin:35px 0; font-family: 'Inter', sans-serif!important;"    >2021 © All rights reserved.</p>
           
        </div>
      </div>
       
    
    </div>
  </div>
</div>

   </div>


</template>

<script>
  const fb = require('../firebase/firebaseconfig.js')
 import axios from 'axios'

export default {
 
     
      props:['wlgigs','loaded','signedin','countrycode','fav','favall','wlgigobj','userinfo','userdataloaded'],
  data () {

        return{
   signedinby:'google',
   name:'',
   chid:'',
   editbox:false,
   formsubmited:false,
   addboxs:false,
   cid:'',
   tab:0,
   editdata:{},
   question:[{
    id:0,
    title:'Enter your Name',
    answer:'',
    type:'input',
    error:false,
   },
   {
    id:1,
    title:'What would you like to do?',
    answer:'',
    type:'option',
    options:['Extend Video','Hold Video','Resume Video','Set Deadline After Feedback'],
      error:false,
   }],
   deldata:{},
   delbox:false,
   bid:'',
   addbox:false,
   editboxsss:false,
   profiletext:'',
   leads:[],
   tempmanager:null,
   cusitems:{  x:150,
  y:150,
  width:300,
  height:300,
  angle:0,}, 
   items:{
  x:150,
  y:150,
  width:300,
  height:300,
  angle:0,

},

   drawer:false,
   name:'',
   searchtxt:'',
 key:'all',

 
        }
     
    
  },
    created(){



 this.tab=this.$route.query.id
 
if(fb.auth.currentUser!=null){

 var vm=this

 fb.db.collection('mondayhook').onSnapshot(async(querySnapshot)=>{
  var wlgigs=[]
  var wlgigobj={}
 
  querySnapshot.forEach((doc)=> {

 

 
wlgigs.push({id:doc.id,...doc.data()})


})

var getmans=wlgigs.filter((itm)=>{
  return itm.type=='manager'
})



var newwlgigs=[]




  for(var i=0;i<getmans.length;i++){
if(i==0){
if(this.tempmanager==null){


    this.tempmanager={
              ...getmans[i],selected:true
            }
            newwlgigs.push({ ...getmans[i],selected:true})

          }else{

            if(this.tempmanager.creatorid==getmans[i].creatorid){
               newwlgigs.push({ ...getmans[i],selected:true})
            }else{
               newwlgigs.push({ ...getmans[i],selected:false})
            }
           


}

}else{
 if(this.tempmanager!=null){
  if(this.tempmanager.creatorid==getmans[i].creatorid){
               newwlgigs.push({ ...getmans[i],selected:true})
            }else{
               newwlgigs.push({ ...getmans[i],selected:false})
            }

          }else{

             newwlgigs.push({ ...getmans[i],selected:false})

          }




}

  }





var getmemb=wlgigs.filter((itm)=>{
  return itm.type=='member'
})

var wlgigss=[
...newwlgigs,
...getmemb
]



 
  vm.leads=[
  ...wlgigss
  ]



})



 
if( fb.auth.currentUser.providerData[0].providerId=='google.com'){


  var x=fb.auth.currentUser.photoURL.split('wlshops').length-1
 



  this.profileimg=fb.auth.currentUser.photoURL.split('wlshops')[x]

    this.signedinby='google'



}else{
 
  this.signedinby='email'
 


}
}

  },
  mounted(){ 


 
 
   (function(w, d, $) {

 


$('li.menu-item-has-children > a').on("click touch", function(e) {
 

        e.preventDefault();
        if($(w).width() <= 768) {


          $('.sub-menu').css('min-width', $(w).width());
          $('.sub-menu-column .sub-menu').css('min-width', '0px');
          $('.products-sub-menu .sub-menu').css('min-width', $(w).width()-50);
          if( $(this).hasClass('on') ) {
            if($(this).parent().hasClass('sub-menu-columns')){
              $(this).next('.sub-menu').slideUp(350);
              $(this).removeClass('on');
            } else if($(this).parent().hasClass('sub-menu-column')){
              $(this).next('.sub-menu').slideUp(350).delay(150).queue(function (next) {
                $(this).parent('.sub-menu-column').css('height', 'auto');
                next();
              });
              $(this).removeClass("on");
            } else if($(this).parent('li.menu-item-has-children').hasClass('login-menu')) {
              $(this).next('.sub-menu').slideUp(350);
              $(this).removeClass('on');
              $(this).parents('.nav-right').css('background-color', '#FFF');
            } else {
              $(this).next('.sub-menu').slideUp(350);
              $(this).removeClass('on');
            }
          }
          else {
            if($(this).parent().hasClass('sub-menu-columns')){
              $("li.menu-item-has-children > a").not($(this)).next('.sub-menu').slideUp(350).delay(350).queue(function (next) {
                $('.sub-menu-column').css('height', 'auto');
                next();
              });
              $("li.menu-item-has-children > a").not($(this)).removeClass("on");
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            } else if($(this).parent().hasClass('sub-menu-column')){
              let submenuHeight1 = $(this).next('.sub-menu').height();
              $(this).parent('.sub-menu-column').css('height', 63+submenuHeight1);
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            } else if($(this).parent('li.menu-item-has-children').hasClass('login-menu')) {
              $(this).parents('.nav-right').css('background-color', '#F9FCFC');
              $("li.menu-item-has-children > a").not($(this)).next('.sub-menu').slideUp(350).delay(350).queue(function (next) {
                $('.sub-menu-column').css('height', 'auto');
                next();
              });
              $("li.menu-item-has-children > a").not($(this)).removeClass("on");
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            } else {
              $("li.menu-item-has-children > a").not($(this)).next('.sub-menu').slideUp(350).delay(350).queue(function (next) {
                $('.sub-menu-column').css('height', 'auto');
                next();
              });
              $("li.menu-item-has-children > a").not($(this)).removeClass("on");
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            }
          }
        }
      });



var toggleClose = $('.close'),
menuWrapper = $('.main-nav'),
          bodyControl     = $('body'),
          mouse_is_inside = false;


      $('.navigate').click( function() {

   
        bodyControl.removeClass("active");
        menuWrapper.addClass("active");
        bodyControl.addClass("active");
        return false;
      });


      toggleClose.click( function() {
        bodyControl.removeClass("active");
        menuWrapper.removeClass("active");
        return false;
      });

      })(window, document, jQuery);

} 
   ,
  computed:
  {
 
    getmanager(){
      var c=this.leads.filter((itm)=>{
        return itm.type=='manager'
      })


      return c
    },
    getmember(){
      var c=this.leads.filter((itm)=>{
        return itm.type=='member' && itm.manager.id==this.tempmanager.creatorid
      })
      return c
    },

    filtercat(){
      
 
if(this.key=='all'){

 return this.wlgigs

}else{


            var x=this.wlgigs.filter((itm)=>{

              return itm.category.match(this.key)

            })

            return x
}
         
    },

initswiper(){



  setTimeout(()=>{
 const swiper = new Swiper('.swiper-container', {
  // Optional parameters
 
  loop: true,
 

 slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        loop:false,
        breakpoints: {
           300: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        },

});




  },100)
 
}
 
 

  },

   
  methods:{ 

setroute(id){
   
   this.$router.push({ path: '/formtest?id='+(id+1)})

},


setstate(status,itm,index){



if(status=='down'){


 if(itm.answer==''){
  itm.error=true
  return
}
this.tab=itm.id+1
}else{
this.tab=itm.id-1
}


},
submit(){


console.log(this.question)

var type=this.question[1].answer



if(type=='Set Deadline After Feedback'){
  
 
var x={
  attributes:[
  {
    Name:'pulseid',
    Value:this.$route.query.pulseid
  }],
  question:this.question
}

const options = {
  url: 'https://us-central1-staging-wlshop.cloudfunctions.net/test',
  method: 'POST',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  data:JSON.stringify(x)
};

axios(options)
  .then(response => {
 
    console.log(response.status);
  });


this.formsubmited=true
this.question=[{
    id:0,
    title:'Enter your Name',
    answer:'',
    type:'input'
   },
   {
    id:1,
    title:'What would you like to do?',
    answer:'',
    type:'option',
    options:['Extend Video','Hold Video','Resume Video'],
   }]

   this.tab=0

return
}




if(type=='Extend Video'){
  
 
var x={
  attributes:[{
    Name:'timelineid',
    Value:this.$route.query.timelineid
  },{
    Name:'startdate',
    Value:this.$route.query.startdate
  },
  {
    Name:'pulseid',
    Value:this.$route.query.pulseid
  }],
  Question_2_Answer_1:type,
  Question_3_Answer_1:Number(this.question[2].answer)
}


}else{

 
var x={
  attributes:[{
    Name:'timelineid',
    Value:this.$route.query.timelineid
  },{
    Name:'startdate',
    Value:this.$route.query.startdate
  },
  {
    Name:'pulseid',
    Value:this.$route.query.pulseid
  }],
  Question_2_Answer_1:type,
  Question_3_Answer_1:0
}
}






const options = {
  url: 'https://us-central1-staging-wlshop.cloudfunctions.net/test',
  method: 'POST',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  data:JSON.stringify(x)
};

axios(options)
  .then(response => {
    alert('sss')
    console.log(response.status);
  });


this.formsubmited=true
this.question=[{
    id:0,
    title:'Enter your Name',
    answer:'',
    type:'input'
   },
   {
    id:1,
    title:'What would you like to do?',
    answer:'',
    type:'option',
    options:['Extend Video','Hold Video','Resume Video'],
   }]

   this.tab=0


},
setmore(option,index,itm){

  var tempqus=[
      ...this.question.slice(0,2)
  ]



var tempqu=tempqus.map((itm)=>{
  if(itm.id==index){
    
      return {
        ...itm,
        answer:option
      }
  }else{
    return itm
  }
})



  var hold=[{
    id:2,
    title:'Why do you want to Hold Video',
    answer:'',
    type:'input',
      error:false,
   }]
   var extend=[{
    id:2,
    title:'How many days do you want to add to your current xxxxx deadline ? (counting only the no. of working days you want to add, excluding holidays)',
    answer:'',
      error:false,
    type:'input'
   },
   {
    id:3,
    title:'Why do you want to Extend Deadline',
    answer:'',
      error:false,
    type:'input'
   }]

      var resume=[{
    id:2,
    title:'Why do you want to Resume Video',
    answer:'',
      error:false,
    type:'input'
   }]

    var deadline=[{
    id:2,
    title:'How many feedbacks were there?',
    answer:'',
      error:false,
    type:'input'
   },
   {
    id:3,
    title:'How many days need to complete the feedback corrections?',
    answer:'',
      error:false,
    type:'input'
   }]


var question=this.question.map((itm)=>{
  if(itm.id==index){

      return {
        ...itm,
        answer:option
      }
  }else{
    return itm
  }
})

if(option=='Extend Video'){


this.question=[
...tempqu,
...extend
]
this.tab=itm.id+1
}
else if(option=='Resume Video'){
  this.question=[
...tempqu,
...resume
]
this.tab=itm.id+1
}
else if(option=='Set Deadline After Feedback'){
  this.question=[
...tempqu,
...deadline
]
this.tab=itm.id+1
}
else {
this.question=[
...tempqu,
...hold
]
this.tab=itm.id+1
}

 

},
      editboxs(item){
        this.editdata={
          ...item
        }
        this.editbox=true
        this.name=item.name
this.cid=item.creatorid
this.bid=item.boardid
this.chid=item.channelid
    },
     editboxss(item){
        this.editdata={
          ...item
        }
        this.editboxsss=true

        this.name=item.name
this.cid=item.creatorid
this.bid=item.boardid
 
    },

    setsel(index){
        var x=this.leads.map((itm,ind)=>{
          if(index==ind){
            this.tempmanager={
              ...itm
            }
              return{
              ...itm,
              selected:true
            }
          }else{
            return{
              ...itm,
              selected:false
            }
          }
        })

        this.leads=[
        ...x
        ]
    },
    delboxs(item){

      this.deldata={
        ...item
      }
      this.delbox=true
    },
    adduser(){
      var x={
        name:this.name,
        creatorid:Number(this.cid),
        boardid:Number(this.bid),
        channelid:this.chid,
        type:'manager'
      }
         fb.db.collection('mondayhook').add({
                ...x
         }).then(()=>{

          this.name=''
          this.cid=''
          this.bid=''
          this.chid=''
          this.addbox=false

         })
    },
     edituser(){
      var x={
        name:this.name,
        creatorid:Number(this.cid),
        boardid:Number(this.bid),
        channelid:this.chid,
       
      }
         fb.db.collection('mondayhook').doc(this.editdata.id).update({
                ...x
         }).then(()=>{

          this.name=''
          this.cid=''
          this.bid=''
          this.chid=''
          this.editbox=false
          this.editdata={}

         })
    },

     editusers(){
      var x={
        name:this.name,
        creatorid:Number(this.cid),
        boardid:Number(this.bid),
      
       
      }
         fb.db.collection('mondayhook').doc(this.editdata.id).update({
                ...x
         }).then(()=>{

          this.name=''
          this.cid=''
          this.bid=''
          this.chid=''
          this.editboxsss=false
          this.editdata={}

         })
    },


      addusers(){
      var x={
        name:this.name,
        creatorid:Number(this.cid),
        boardid:Number(this.bid),
        type:'member',
        manager:{
          id:this.tempmanager.creatorid,
          channelid:this.tempmanager.channelid
         }
      }
         fb.db.collection('mondayhook').add({
                ...x
         }).then(()=>{

          this.name=''
          this.cid=''
          this.bid=''
          this.chid=''
          this.addboxs=false

         })
    },
    deleteconf(){
fb.db.collection('mondayhook').doc(this.deldata.id).delete()
this.delbox=false
    },
rotatestarts(vals){
  console.log(vals)
  this.cusitems={
    ...vals,
    width:vals.w,
    height:vals.h
  }
},
resizestarts(vals){
  console.log(vals)
  this.cusitems={
    ...vals,
    width:vals.w,
    height:vals.h
  }
},
dragstarts(vals){
  console.log(vals)
  this.cusitems={
    ...vals,
    width:vals.w,
    height:vals.h
  }
},
renderprice(price){
  if(price.length==4){
 return price[0]+','+price.slice(1,price.length)
  }
  else if(price.length==5){
 return price.slice(0,2)+','+price.slice(2,price.length)
  }
  else{
     return price
  }
 
},
setkey(key){

this.key=key
},
    searchnow(){


        this.$router.push({ path: '/search',query:{for:this.searchtxt}})
 
    },
 setfav(id){
          
          if(fb.auth.currentUser!=null){


  fb.db.collection('wlshopusers').doc(fb.auth.currentUser.uid).collection('favourites').add({
    id:id
  })
    }else{
      this.$router.push({path:'/login'})
    }

    },

     delfav(id){
if(fb.auth.currentUser!=null){


var x=this.favall.filter((itm)=>{

  return itm.id==id
})


 
fb.db.collection('wlshopusers').doc(fb.auth.currentUser.uid).collection('favourites').doc(x[0].ids).delete()



}


    },
    loginroute(){

        this.$router.push({ path: '/login'})

    },
    routepage(titles){
 

  

 var replaced = titles.split(' ').join('-');


 this.$router.push({ name: 'gigview',params:{title:replaced}})

    },
     signout(){
 
      fb.auth.signOut()
     this.$emit('setsignedin',false)
    },

     renderbasicpackage(item){


var y={}


 
item.packages.forEach((itm)=>{

 

if(itm.rowcontent1=='price'){
y[itm.rowcontent1]=itm.rowcontent2 

}else{
  y[itm.rowcontent1]=itm.rowcontent2 +' '+itm.rowcontent1

}


 })

 return y


 }

  }
 

   
   
    
 
  
}
</script>
<style scoped >
 
</style>
 



// WEBPACK FOOTER //
// src/components/formtest.vue